<template>
  <svg viewBox="0 0 40 40" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M8 0.75H24C24.1212 0.75 24.2375 0.798088 24.3232 0.883789L35.1162 11.6768C35.2019 11.7625 35.25 11.8788 35.25 12V36C35.25 37.7949 33.7949 39.25 32 39.25H8C6.20507 39.25 4.75 37.7949 4.75 36V4C4.75 2.20507 6.20508 0.75 8 0.75Z"
      fill="white"
      stroke="#D5D7DA"
      stroke-width="1.5"
    />
    <path d="M24 0.5V8C24 10.2091 25.7909 12 28 12H35.5" stroke="#D5D7DA" stroke-width="1.5" />
    <path
      d="M25.25 30.75H26.0078C26.7361 30.75 27.1003 30.75 27.3011 30.5981C27.476 30.4658 27.5842 30.2636 27.5973 30.0447C27.6123 29.7934 27.4102 29.4904 27.0062 28.8844L24.7484 25.4977C24.4146 24.9969 24.2477 24.7465 24.0373 24.6593C23.8533 24.583 23.6466 24.583 23.4627 24.6593C23.2523 24.7465 23.0854 24.9969 22.7515 25.4977L22.1934 26.3349M25.25 30.75L19.4866 22.4251C19.1552 21.9464 18.9894 21.707 18.7824 21.6228C18.6013 21.5492 18.3986 21.5492 18.2175 21.6228C18.0105 21.707 17.8448 21.9464 17.5134 22.4251L13.0536 28.8669C12.6314 29.4769 12.4202 29.7819 12.4322 30.0355C12.4427 30.2564 12.5501 30.4614 12.7258 30.5957C12.9275 30.75 13.2984 30.75 14.0403 30.75H25.25ZM26.75 19.5C26.75 20.7426 25.7426 21.75 24.5 21.75C23.2573 21.75 22.25 20.7426 22.25 19.5C22.25 18.2574 23.2573 17.25 24.5 17.25C25.7426 17.25 26.75 18.2574 26.75 19.5Z"
      stroke="#414651"
      stroke-width="1.5"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
  </svg>
</template>
